import TypedSections from './TypedSections';

export default TypedSections;
